export default __webpack_public_path__ + "static/img/vogue_scene_animated_0337.4401b28.jpg";